export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9957.f1e021ea.jpg";